import Vue from "vue";
import moment from "moment";

// Display the Currency Sign based on the country code
Vue.filter("currencySign", (item) => {
  let value;
  switch (item) {
    case "NGN":
      value = "₦";
      break;
    case "GHS":
      value = "GH₵";
      break;
    case "KES":
      value = "KSh";
      break;
    case "UGX":
      value = "USh";
      break;
    case "USD":
      value = "$";
      break;
    case "ZAR":
      value = "R";
      break;
    case "EUR":
      value = "€";
      break;
    case "GBP":
      value = "£";
      break;
    default:
      value = "";
  }

  return value;
});

Vue.filter("currencyName", (item) => {
  let value;
  switch (item) {
    case "NGN":
      value = "Naira";
      break;
    case "GHS":
      value = "Ghanaian cedi";
      break;
    case "KES":
      value = "Kenyan shilling";
      break;
    case "UGX":
      value = "Ugandan shilling";
      break;
    case "USD":
      value = "United States Dollar";
      break;
    case "ZAR":
      value = "South African rand";
      break;
    case "EUR":
      value = "Euro";
      break;
    case "GBP":
      value = "Pound sterling";
      break;
    default:
      value = "";
  }

  return value;
});

// Format Money values into commas
Vue.filter("money", (item) => {
  if (typeof item !== "undefined" && item !== null) {
    let decimalValue = item.toFixed(2);
    return decimalValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
});

Vue.filter("numberspace", (item) => {
  if (typeof item !== "undefined" && item !== null) {
    let decimalValue = item;
    return decimalValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
});

// Format Calendar days ( today, tomorrow, some secs ago etc)
Vue.filter("calendar", (item) => {
  return moment(item, "YYYY-MM-DD HH:mm:ss").calendar();
});

// Format Calendar days default format ( today, tomorrow, some secs ago etc)
Vue.filter("date", (item) => {
  return moment(item).format("ll");
});

// Format Calendar days default format ( today, tomorrow, some secs ago etc)
Vue.filter("mostrecent", (item) => {
  return moment(item).calendar();
});

// Like CSS capitalize ( capitalize the first word )
Vue.filter("capitalize", (str) => {
  if (typeof str !== "undefined") {
    let splitStr = str.toLowerCase().split(" ");
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  }
});

// Initials for Avatars
Vue.filter("initials", (item) => {
  if (item !== null && item !== "") {
    let initials = "";
    let name = item.split(" ");
    if (typeof name[1] == "undefined") {
      initials = item.slice(0, 2);
    } else {
      initials = name[0].slice(0, 1) + name[1].slice(0, 1);
    }
    return initials;
  }
});

// Check if a value is present and return N/A if not
Vue.filter("availability", (str) => {
  if (str) {
    return str.toString().length ? str : "N/A";
  } else return "N/A";
});
